"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormModelFieldNestedListBuilderValue = exports.FormModelFieldNestedListBuilderGroup = exports.FormModelFieldNestedListBuilder = void 0;
var tslib_1 = require("tslib");
/**
 * Constructs the entire NestedList options object to avoid individual sets which are expensive due to deep-cloning.
 *
 * This provides a wrapper around the internal nested list data, these helper classes will just have deep references inside the data.
 * Which also means they will generally not be == comparable, check the paths & value.
 */
var FormModelFieldNestedListBuilder = /** @class */ (function () {
    function FormModelFieldNestedListBuilder(options) {
        if (options != null) {
            this.group = new FormModelFieldNestedListBuilderGroup(options);
        }
    }
    Object.defineProperty(FormModelFieldNestedListBuilder.prototype, "options", {
        get: function () {
            if (this.group != null) {
                return this.group.options;
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    FormModelFieldNestedListBuilder.prototype.createGroup = function (title) {
        if (this.group != null && this.group.options.title.length > 0) {
            if (title === this.group.options.title) {
                return this.group;
            }
            throw new Error("Cannot rename group from \"".concat(this.group.options.title, "\" to \"").concat(title, "\""));
        }
        this.group = new FormModelFieldNestedListBuilderGroup({ title: title, values: [] });
        return this.group;
    };
    FormModelFieldNestedListBuilder.prototype.getGroup = function (path) {
        var e_1, _a;
        var opts = this.group.options;
        try {
            for (var path_1 = tslib_1.__values(path), path_1_1 = path_1.next(); !path_1_1.done; path_1_1 = path_1.next()) {
                var pathIndex = path_1_1.value;
                if (opts == null || opts.values == null || pathIndex >= opts.values.length) {
                    return null;
                }
                opts = opts.values[pathIndex].options;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (path_1_1 && !path_1_1.done && (_a = path_1.return)) _a.call(path_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (opts == null || opts.values == null) {
            return null;
        }
        return new FormModelFieldNestedListBuilderGroup(opts);
    };
    FormModelFieldNestedListBuilder.prototype.getValue = function (path) {
        var group = this.getGroup(path.slice(0, path.length - 1));
        if (group == null) {
            return null;
        }
        return group.getValue(path[path.length - 1]);
    };
    return FormModelFieldNestedListBuilder;
}());
exports.FormModelFieldNestedListBuilder = FormModelFieldNestedListBuilder;
var FormModelFieldNestedListBuilderGroup = /** @class */ (function () {
    function FormModelFieldNestedListBuilderGroup(options) {
        if (options == null) {
            this.options = { title: '', values: [] };
        }
        else {
            this.options = options;
        }
    }
    Object.defineProperty(FormModelFieldNestedListBuilderGroup.prototype, "title", {
        get: function () {
            return this.options.title;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelFieldNestedListBuilderGroup.prototype, "size", {
        get: function () {
            return this.options.values.length;
        },
        enumerable: false,
        configurable: true
    });
    FormModelFieldNestedListBuilderGroup.prototype.setTitle = function (title) {
        this.options.title = title;
    };
    FormModelFieldNestedListBuilderGroup.prototype.createValue = function (value, code, color, index) {
        var existingValue = this.options.values.find(function (v) { return v.value === value; });
        var existingColor = this.options.values.find(function (v) { return v.color === color; });
        if (existingValue && existingColor) {
            return new FormModelFieldNestedListBuilderValue(existingValue);
        }
        var newValue = { value: value, code: code, color: color };
        if (index != null) {
            this.options.values.splice(index, 0, newValue);
        }
        else {
            this.options.values.push(newValue);
        }
        return new FormModelFieldNestedListBuilderValue(newValue);
    };
    FormModelFieldNestedListBuilderGroup.prototype.getValue = function (index) {
        if (index >= 0 && index < this.options.values.length) {
            return new FormModelFieldNestedListBuilderValue(this.options.values[index]);
        }
        return null;
    };
    FormModelFieldNestedListBuilderGroup.prototype.findValue = function (str) {
        var index = this.options.values.findIndex(function (f) { return f.value === str; });
        return this.getValue(index);
    };
    FormModelFieldNestedListBuilderGroup.prototype.deleteValue = function (index) {
        this.options.values.splice(index, 1);
    };
    return FormModelFieldNestedListBuilderGroup;
}());
exports.FormModelFieldNestedListBuilderGroup = FormModelFieldNestedListBuilderGroup;
var FormModelFieldNestedListBuilderValue = /** @class */ (function (_super) {
    tslib_1.__extends(FormModelFieldNestedListBuilderValue, _super);
    function FormModelFieldNestedListBuilderValue(listValues) {
        var _this = _super.call(this) || this;
        _this.listValues = listValues;
        return _this;
    }
    Object.defineProperty(FormModelFieldNestedListBuilderValue.prototype, "value", {
        get: function () {
            return this.listValues.value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelFieldNestedListBuilderValue.prototype, "color", {
        get: function () {
            return this.listValues.color;
        },
        enumerable: false,
        configurable: true
    });
    FormModelFieldNestedListBuilderValue.prototype.setValue = function (value) {
        this.listValues.value = value;
    };
    FormModelFieldNestedListBuilderValue.prototype.setColor = function (color) {
        this.listValues.color = color;
    };
    FormModelFieldNestedListBuilderValue.prototype.createGroup = function (title) {
        if (this.listValues.options != null && this.listValues.options.title === title) {
            return new FormModelFieldNestedListBuilderGroup(this.listValues.options);
        }
        var group = _super.prototype.createGroup.call(this, title);
        this.listValues.options = group.options;
        return group;
    };
    return FormModelFieldNestedListBuilderValue;
}(FormModelFieldNestedListBuilder));
exports.FormModelFieldNestedListBuilderValue = FormModelFieldNestedListBuilderValue;
//# sourceMappingURL=form.nested.list.builder.js.map